import TweenMax from "gsap";
require("./one-by-one.less");
/**
 *
 */
export default class OneByOne{
    constructor($main,speed=1,lockCenter){
        let me = this;
        this.$main=$main;
        this.lockCenter=lockCenter;
        this.$content=this.$main.find(".content");
        this.$items=this.$content.find(".item");
        setInterval(function(){
            me.loop();
        },10);
        this.$main.height(this._itemsCount()*this._itemHeight()*(1/speed))
        this._lastActive=false;
    }

    _itemsCount(){
        return this.$items.length;
    }
    _itemHeight(){
        return this.$items.outerHeight();
    }

    loop(){
        let itemsCount=this._itemsCount();
        let scrolll = $(window).scrollTop();
        let docH = $(document).height();
        let winH = $(window).height();
        let percent = (scrolll / (docH - winH)) * 100;
        let contentH=this.$content.height();
        let itemH=this._itemHeight();

        let min=winH/2 - itemH/2;
        let max=winH /2  - contentH + itemH / 2;

        let y=this.ratio(
            percent,
            100,
             max,
            0,
             min
        );
        //actif ?
        let active=this.ratio(percent,100,itemsCount-1,0,0);
        active=Math.round(active);
        if(active !== this._lastActive){
            this.$items.removeAttr("the-one");
            this.$items.eq(active).attr("the-one","");
        }
        if(this.lockCenter){
            y=this.ratio(active,itemsCount-1,max,0,min);
        }
        TweenMax.set(this.$content,{"top":y});
        /*
        console.log("scrolll",scrolll);
        console.log("winH",winH);
        console.log("docH",docH);
        console.log("contentH",contentH);
        console.log("y",y);
         */
        console.log(itemH);

        //TweenMax.to(this.$content,0.5,{"top":y});


    }

    /**
     *
     * @param {number} inputValue
     * @param {number} inputMax
     * @param {number} outputMax
     * @param {number} inputMin
     * @param {number} outputMin
     * @returns {number}
     */
    ratio(inputValue, inputMax, outputMax, inputMin=.0, outputMin=.0){
        let product = (inputValue - inputMin) / (inputMax - inputMin);
        return ((outputMax - outputMin) * product) + outputMin;
    };
}

module.export=OneByOne;